module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', [_vm._v("Trials By Investigators")]), _vm._v(" "), (_vm.investigators == false) ? _c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "new_releases",
      "value": true
    }
  }, [_vm._v("\n          There are no investigators.\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": "",
      "sm11": "",
      "md11": "",
      "align-content-space-between": "",
      "mt-4": "",
      "mb-0": "",
      "ml-0": "",
      "mr-0": ""
    }
  }, _vm._l((_vm.investigators), function(item) {
    return _c('v-card', {
      key: item.investigatorId,
      staticClass: "info",
      attrs: {
        "to": '/Trials/investigators/' + item.investigatorId
      }
    }, [_c('v-list', {
      staticClass: "listItems"
    }, [_c('v-list-tile', {
      staticClass: "pb-2 pt-2 pl-2"
    }, [_c('v-list-tile-avatar', [_c('investigator-icon', {
      staticClass: "icon",
      attrs: {
        "left": ""
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', {
      staticClass: "pl-2"
    }, [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(item.investigatorName)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "light": "",
        "flat": "",
        "ripple": ""
      }
    }, [_c('right-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey'
      }
    })], 1)], 1)], 1)], 1)], 1)
  })), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-flex', {
    attrs: {
      "xs2": "",
      "sm1": "",
      "md1": "",
      "ml-0": "",
      "mr-0": "",
      "mb-0": "",
      "mt-4": "",
      "justify-center": ""
    }
  }, _vm._l((_vm.investigators), function(item2, index2) {
    return _c('v-card', {
      key: item2.investigatorId,
      staticClass: "info"
    }, [_c('v-list', {
      staticClass: "listItems pa-0"
    }, [_c('v-list-tile', {
      staticClass: "pa-2"
    }, [_c('app-edit-investigator-dialog', {
      attrs: {
        "investigator": _vm.investigator(index2)
      }
    })], 1)], 1)], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-4": ""
    }
  }, [_c('v-card', {
    attrs: {
      "to": '/investigator/new'
    }
  }, [(_vm.userIsAuthenticated) ? _c('v-card-text', {
    staticClass: "cyanLight editDialogsRow"
  }, [_vm._v("\n          Add Investigator\n          "), _c('v-icon', {
    staticClass: "text-xs-right"
  }, [_vm._v("add")])], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-402be9fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Trials/Investigators/Archive.vue
// module id = 675
// module chunks = 1